import ProductDetailsScreen from './ProductDetailsScreen';

export default ProductDetailsScreen;
